
import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/ingredients',
    meta: { title: '原料入场验收' },
    component: Layout,
    redirect: '/ingredients/list',
    children: [
      {
        path: 'list',
        meta: { title: '原料入场验收', activeMenu: '/ingredients' },
        component: () => import('@/views/ingredients/Ingredients.vue')
      },
      {
        path: 'detail',
        meta: { title: '原料入场验收详情', activeMenu: '/ingredients' },
        component: () => import('@/views/ingredients/IngredientsDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑原料入场验收', activeMenu: '/ingredients' },
        component: () => import('@/views/ingredients/IngredientsAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增原料入场验收', activeMenu: '/ingredients' },
        component: () => import('@/views/ingredients/IngredientsAdd.vue')
      }

    ]
  }

]
